import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

interface StyledTooltipProps {
  border: boolean;
}

const TooltipWithProps = ({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
);

export const StyledTooltip = styled(TooltipWithProps, {
  shouldForwardProp: isPropValid,
})<StyledTooltipProps>(({ border }) => ({
  '& .MuiTooltip-tooltip': {
    background: 'var(--tra-color-neutral-600)',
    border: border ? `1px solid var(--tra-color-neutral-500)` : 0,
    borderRadius: 0,
  },
  '& .MuiTooltip-arrow': {
    '&::before': {
      background: 'var(--tra-color-neutral-600)',
      border: border ? `1px solid var(--tra-color-neutral-500)` : 0,
    },
  },
}));
